import type {AsyncValidationFunction} from '../internal/async-validations';


export class KpValueEditorConfigurationService {
    public static readonly serviceName = 'valueEditorConfigurationService';

    #debugMode = false;
    private asyncValidationFunction: AsyncValidationFunction;

    /**
     * @ngdoc method
     * @name kpValueEditorConfigurationService#setDebugMode
     *
     * @param {boolean} isEnabled
     *
     * @description
     * Enable / disable debug mode. It shows / hide information section below value editor.
     */
    public setDebugMode(isEnabled: boolean) {
        this.#debugMode = isEnabled;
    }

    public get debugMode() {
        return this.#debugMode;
    }

    /**
     * @ngdoc method
     * @name KpValueEditorConfigurationService#setValidationFunction
     *
     * @param {validationFunction} validationFunction User-specified validation function.
     *
     * @description
     * Setter for validation function. Validation function is called every time when async validation is triggered.
     * Function returns Promise depending on validation result.
     * If value is valid it should be resolved to true. If validation failed, promise will be rejected.
     * Rejection reason should be `string` which will be displayed as validation error message.
     *
     * If validation succeeds, promise will be resolved.
     *
     *
     * | Argument&nbsp;name      | Description                                                                                     |
     * | ----------------------- | ----------------------------------------------------------------------------------------------- |
     * | `fieldName`             | Field name passed from `editorName` attribute of editor component                               |
     * | `value`                 | Current field value                                                                             |
     * | `form`                  | If `sendWholeForm` {@link type:KpAsyncValidationOptions option} is true, it contains form model |
     * | `additionalParameters`  | Some static parameters passed from `additionalParameters` in options.                           |
     */
    public setValidationFunction(validationFunction: AsyncValidationFunction) {
        this.asyncValidationFunction = validationFunction;
    }

    public getValidationsFunction(): AsyncValidationFunction {
        return this.asyncValidationFunction;
    }
}